import { prefix } from '../../utils/prefix';

const Url = {
  logout: `${prefix}/logout/action`,
  homeDetail: `${prefix}/home/detail`,
  tabLists: `${prefix}/account/tabLists`,
  detail: `${prefix}/info/detail`,
  uploadAttachment: `${prefix}/attachment/upload`,
  deleteAttachment: `${prefix}/attachment/delete`,
  submit: `${prefix}/info/submit`,
  schoolDictIndex: `${prefix}/dataset/school`,
  majorDictIndex: `${prefix}/dataset/major`,
  titleDictIndex: `${prefix}/dataset/professionalTitle`,
  pinYinXingId: `${prefix}/dataset/pinYinXing`,
  pinYinMingId: `${prefix}/dataset/pinYinMing`,
  validateWorksInfo: `${prefix}/info/worksInfo/validateWorksInfo`,
  positionSimpleInfo: `${prefix}/info/positionSimpleInfo`,
  feedback: `${prefix}/account/feedback`,
  getWorkerType: `${prefix}/info/workerType`,
  getBaseInfo: `${prefix}/info/basicInfo/get`,
  getPersonalInfo: `${prefix}/info/personalInfo/get`,
  /** 查询办公电脑是否符合当前JF/JG */
  getComputerType: `${prefix}/info/computerType/matching`,
};
export default Url;
